"use client";

import * as React from "react";
import { Zap, Droplet, CakeSlice, Utensils, Quote, Flame, Wine } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const quotes = [{
  text: "A wedding feast should be as memorable as the vows themselves.",
  author: "VOW Culinary Director"
}, {
  text: "We blend seasonal ingredients with artistic presentation to create magic.",
  author: "Executive Chef"
}, {
  text: "Every plate tells a story of love, tradition, and modern elegance.",
  author: "The VOW Experience"
}];
const fuelTips = [{
  title: "Artisanal Hors d'Oeuvres",
  content: "Begin your celebration with hand-crafted bites that feature local textures and global flavors, designed to spark conversation and delight the palate.",
  icon: Utensils
}, {
  title: "Signature Pairings",
  content: "Our sommeliers curate a selection of fine wines and bespoke cocktails that perfectly complement each course of your custom wedding menu.",
  icon: Wine
}, {
  title: "The Main Course",
  content: "From sustainably sourced seafood to prime cuts, our entrees are prepared with precision and served with the grace of a five-star dining experience.",
  icon: Flame
}, {
  title: "Midnight Delicacies",
  content: "Keep the energy high on the dance floor with sophisticated late-night snacks, ranging from gourmet sliders to artisanal dessert stations.",
  icon: Droplet
}, {
  title: "Custom Patisserie",
  content: "Our pastry team works with you to design a wedding cake and dessert table that serves as a stunning visual and culinary centerpiece.",
  icon: CakeSlice
}];
export default function CulinaryExcellence() {
  return <section data-section-id="259421" id="culinary-excellence" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] bg-secondary/10 blur-[120px] rounded-lg" />
        <div className="absolute bottom-[10%] -right-[10%] w-[40%] h-[40%] bg-secondary/10 blur-[100px] rounded-lg" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="flex flex-col justify-center h-full">
            <div className="mb-8">
              <Quote className="size-12 text-secondary opacity-40" />
            </div>
            <Carousel opts={{
            loop: true,
            align: "start"
          }} className="w-full max-w-xl">
              <CarouselContent>
                {quotes.map((quote, i) => <CarouselItem data-index={i} key={i}>
                    <div className="flex flex-col space-y-8 py-4">
                      <blockquote className="space-y-6">
                        <p className="font-default italic text-4xl md:text-5xl lg:text-6xl leading-tight text-foreground font-light tracking-tight">
                          "{quote.text}"
                        </p>
                        <footer className="flex items-center gap-4">
                          <div className="h-px w-12 bg-secondary" />
                          <span className="font-mono font-medium text-muted-foreground uppercase tracking-widest text-sm">
                            {quote.author}
                          </span>
                        </footer>
                      </blockquote>
                    </div>
                  </CarouselItem>)}
              </CarouselContent>
              <div className="flex items-center gap-4 mt-8">
                <CarouselPrevious className="static translate-y-0 translate-x-0 bg-card border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors rounded-md shadow-sm" />
                <CarouselNext className="static translate-y-0 translate-x-0 bg-card border-border hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors rounded-md shadow-sm" />
              </div>
            </Carousel>
          </div>

          {}
          <div className="bg-card/80 backdrop-blur-md border border-border/40 p-6 md:p-10 rounded-md shadow-xl">
            <div className="mb-8">
              <h2 className="text-3xl md:text-4xl font-default font-medium text-foreground mb-2">
                Culinary <span className="text-secondary">Excellence</span>
              </h2>
              <p className="text-muted-foreground font-sans font-light tracking-wide">
                A bespoke dining experience tailored to your celebration.
              </p>
            </div>

            <Accordion type="single" collapsible className="w-full">
              {fuelTips.map((tip, i) => {
              const Icon = tip.icon;
              return <AccordionItem data-index={i} key={i} value={`item-${i}`} className="border-border/30">
                    <AccordionTrigger className="hover:no-underline hover:text-secondary transition-colors py-5">
                      <div className="flex items-center gap-4 text-left">
                        <div className="bg-accent/50 p-2.5 rounded-md border border-border/20 text-secondary">
                          <Icon className="size-5" />
                        </div>
                        <span className="font-default font-semibold text-lg tracking-tight">
                          {tip.title}
                        </span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="text-muted-foreground font-sans font-light leading-relaxed pl-[3.75rem] pb-6 text-base">
                      {tip.content}
                    </AccordionContent>
                  </AccordionItem>;
            })}
            </Accordion>
          </div>

        </div>
      </div>
    </section>;
}